import { render } from "./collegeNames.vue?vue&type=template&id=235d28bd&scoped=true"
import script from "./collegeNames.vue?vue&type=script&lang=js"
export * from "./collegeNames.vue?vue&type=script&lang=js"

import "./collegeNames.vue?vue&type=style&index=0&id=235d28bd&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235d28bd"]])

export default __exports__